import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="space-y-4">
            <div className="relative w-16 h-16">
              <img
                src="https://cdn.abacus.ai/images/596f4458-dae5-434d-803b-c576583d1265.png"
                alt="PixelMatos - Logo da empresa de desenvolvimento de software"
                className="w-full h-full object-contain brightness-0 invert"
                loading="lazy"
              />
            </div>
            <p className="text-sm text-gray-400">
              Transformando ideias em soluções digitais inovadoras para startups e pequenas empresas.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              {['home', 'sobre', 'servicos', 'portfolio'].map((section) => (
                <li key={section}>
                  <button
                    onClick={() => scrollToSection(section)}
                    className="text-sm text-gray-400 hover:text-primary-400 transition-colors capitalize"
                  >
                    {section}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-sm text-gray-400">
                <Mail size={16} className="text-primary-400" />
                <span>contato@pixelmatos.com</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-400">
                <Phone size={16} className="text-primary-400" />
                <span>+55 (11) 9999-9999</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-400">
                <MapPin size={16} className="text-primary-400" />
                <span>São Paulo, Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} PixelMatos. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
